import api from './api'; // Ou o seu cliente HTTP configurado (axios instance)

/**
 * Insere um novo faturamento (Função existente)
 */
export async function faturarAtividade(payload) {
  const response = await api.post('/atividade/fatura', payload);
  return response.data;
}

// Atualizar
export async function atualizarFaturamento(payload) {
  const { idFaturamento, ...dados } = payload;
  const response = await api.put(`/atividade/fatura/${idFaturamento}`, dados);
  return response.data;
}

// Liberar, Entregar Laudo (SIM ou '') ou OBSERVAÇÕES do laudo
export async function atualizarStatusLaudo(idFaturamento, payload) {
  const response = await api.patch(`/atividade/fatura/status/${idFaturamento}`, payload);
  return response.data;
}

// Excluir
export async function excluirFaturamento(idFaturamento) {
  const response = await api.delete(`/atividade/fatura/${idFaturamento}`);
  return response.data;
}

export const buscarAtividades = async (codpac) => {
  const { data } = await api.get(`pacientes/${codpac}/atividades`);
  return data;
};

export function mensagemFaturamento(error, fallback = 'Erro ao processar faturamento.') {
  const data = error?.response?.data;
  const mensagem = data?.mensagem || data?.message || data?.error;
  if (mensagem && data?.detalhe && data.detalhe !== mensagem) {
    return `${mensagem} ${data.detalhe}`;
  }
  return mensagem || error?.message || fallback;
}
